module.exports = __webpack_public_path__ + "b13ded0ccf766f8285af528dc16f9612.png";


//////////////////
// WEBPACK FOOTER
// ./images/east_side_6.png
// module id = 272
// module chunks = 0